import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';


const Navbar = () => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNavbar = () => {
        if (window.scrollY > 20) {
            setScrollNav(true);
        }
        else {
            setScrollNav(false);
        }
    }
    window.addEventListener('scroll', changeNavbar);

    return (
        <div className={scrollNav ? "active sticky-top" : "inactive sticky-top"}>
            <nav className="max-width navbar navbar-expand-lg navbar-light">
                <Link className="navbar-brand" to="/"><span className="angle">&lt;&lt;</span><span className="name">Farhad Hossain</span><span className="angle">&gt;&gt;</span> </Link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link to="/home" className="nav-link" >Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/about" className="nav-link" >About</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/skills" className="nav-link">Skills</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/projects" className="nav-link" >Projects</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/blogs" className="nav-link">Blogs</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact" className="nav-link">Contact</Link>
                        </li>
                    </ul>
                </div>
            </nav >
        </div>
    );
};

export default Navbar;